import React from "react";
import { Navigate } from "react-router-dom";

import Login from "../pages/Authentication/Login";

import Dashboard from "../pages/Dashboard";
import ViewProfile from "../pages/Profile";
import EditProfile from "../pages/Profile/edit";
import Admins from "../pages/Admins";
import CreateAdmin from "../pages/Admins/create";
import ViewAdmin from "../pages/Admins/details";
import EditAdmin from "../pages/Admins/edit";
import Users from "../pages/Users";
import ViewUser from "../pages/Users/details";
import EditUser from "../pages/Users/edit";
import ForgotPassword from "../pages/Authentication/ForgotPassword";
import ResetPassword from "../pages/Authentication/ResetPassword";
import AuditLogs from "../pages/AuditLog";
import RolesList from "../pages/Roles";
import ViewRole from "../pages/Roles/details";
import EditRole from "../pages/Roles/edit";
import CreateRole from "../pages/Roles/create";
import OrdersProduct from "../pages/OrdersProduct";
import ViewOrderProduct from "../pages/OrdersProduct/details";
import OrdersAPI from "../pages/OrdersAPI";
import ViewOrderAPI from "../pages/OrdersAPI/details";
import OrdersInquiry from "../pages/OrdersInquiry";
import ViewOrderInquiry from "../pages/OrdersInquiry/details";
import CreateOrder from "../pages/OrdersInquiry/create";
import ViewNotifications from "../pages/Notifications";
import ViewProducts from "../pages/Products";
import ViewSubscriptions from "../pages/Subscriptions";
import Shorts from "../pages/Shorts";
import CreateShorts from "../pages/Shorts/create"
import EditShort from "../pages/Shorts/edit";
import ViewShort from "../pages/Shorts/details";
import InsurancePolicies from "../pages/Insurance-Policies";
import ViewPolicy from "../pages/Insurance-Policies/details";
import CreatePolicy from "../pages/OrdersProduct/createPolicy";
import EditPolicy from "../pages/Insurance-Policies/edit";
import CreatePolicyInquiry from "../pages/OrdersInquiry/createPolicy";
import UploadQuotation from "../pages/OrdersInquiry/uploadQuotation";
import ChangePassword from "../pages/ChangePassword";
import Banners from "../pages/Banner";
import CreateBanners from "../pages/Banner/create";
import ViewBanner from "../pages/Banner/details";
import EditBanner from "../pages/Banner/edit";
import Requests from "../pages/Requests";
import ViewRequestQuotation from "../pages/Requests/details";
import UploadRequestQuotation from "../pages/Requests/uploadQuotation";
import Orders from "../pages/Orders";
import PurchaseHistory from "../pages/PurchaseHistory";
import CreateMotorProduct from "../pages/ProductMotor/create";
import Settings from "../pages/Settings";
import MotorProduct from "../pages/ProductMotor";
import ViewMotorProduct from "../pages/ProductMotor/details";
import EditMotorProduct from "../pages/ProductMotor/edit";
import EarlyRenewalReminders from "../pages/EarlyRenewalReminders";
import PolicyReconciliation from "../pages/Reports/PolicyReconciliation";
import PaidUninsured from "../pages/Reports/PaidUninsured";


const authProtectedRoutes = [
    {
        path: "/",
        exact: true,
        component: (localStorage.getItem("token") && localStorage.getItem("permissions")) ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
    },    
    { path: "/dashboard", component: <Dashboard /> },
    { path: "/profile", component: <ViewProfile /> },
    { path: "/change-password", component: <ChangePassword /> },
    { path: "/dashboard/profile", component: <ViewProfile /> },
    { path: "/profile/edit", component: <EditProfile /> },
    { path: "/dashboard/profile/edit", component: <EditProfile /> },
    { path: "/admins", component: <Admins /> },
    { path: "/admins/create", component: <CreateAdmin /> },
    { path: "/admins/details/:id", component: <ViewAdmin /> },
    { path: "/admins/edit/:id", component: <EditAdmin /> },
    { path: "/admins/details/:id/edit", component: <EditAdmin /> },
    { path: "/users", component: <Users /> },
    { path: "/users/details/:id", component: <ViewUser /> },
    { path: "/users/edit/:id", component: <EditUser /> },
    { path: "/users/details/:id/edit", component: <EditUser /> },
    { path: "/users/purchase/:user_id", component: <PurchaseHistory /> },
    { path: "/roles", component: <RolesList /> },
    { path: "/roles/details/:id", component: <ViewRole /> },
    { path: "/roles/edit/:id", component: <EditRole /> },
    { path: "/roles/create", component: <CreateRole /> },
    { path: "/orders", component: <Orders /> },
    { path: "/orders/product", component: <OrdersProduct /> },
    { path: "/orders/product/details/:id", component: <ViewOrderProduct /> },
    { path: "/orders/product/create-policy/:id", component: <CreatePolicy /> },
    { path: "/orders/api", component: <OrdersAPI /> },
    { path: "/orders/api/details/:id", component: <ViewOrderAPI /> },
    { path: "/orders/inquiry", component: <OrdersInquiry /> },
    { path: "/orders/inquiry/details/:id", component: <ViewOrderInquiry /> },
    { path: "/orders/inquiry/upload-policy/:id/:policyId", component: <CreatePolicyInquiry /> },
    { path: "/orders/inquiry/create", component: <CreateOrder /> },
    { path: "/orders/inquiry/upload-quotation/:insId/:orderId/:id", component: <UploadQuotation /> },
    { path: "/insurance-policies", component: <InsurancePolicies /> },
    { path: "/early-renewal-reminders", component: <EarlyRenewalReminders /> },
    { path: "/insurance-policies/details/:id", component: <ViewPolicy /> },
    { path: "/insurance-policies/edit/:id", component: <EditPolicy /> },
    { path: "/audit-logs", component: <AuditLogs /> },
    { path: "/notifications", component: <ViewNotifications /> },
    { path: "/products", component: <ViewProducts /> },
    { path: "/subscriptions", component: <ViewSubscriptions /> },
    { path: "/shorts", component: <Shorts /> },
    { path: "/shorts/create", component: <CreateShorts/>},
    { path: "/shorts/edit/:id", component: <EditShort/>},
    { path: "/shorts/details/:id/edit", component: <EditShort/>},
    { path: "/shorts/details/:id", component: <ViewShort/>},
    { path: "/banners", component: <Banners/>},
    { path: "/banners/create", component: <CreateBanners />},
    { path: "/banners/details/:id", component: <ViewBanner/>},
    { path: "/banners/details/:id/edit", component: <EditBanner/>},
    { path: "/banners/edit/:id", component: <EditBanner/>},
    { path: "/requests", component: <Requests /> },
    { path: "/requests/details/:id", component: <ViewRequestQuotation /> },
    { path: "/requests/upload-quotation/:id", component: <UploadRequestQuotation /> },
    { path: "/motor-insurance", component: <MotorProduct /> },
    { path: "/motor-insurance/create", component: <CreateMotorProduct /> },
    { path: "/motor-insurance/details/:id", component: <ViewMotorProduct /> },
    { path: "/motor-insurance/edit/:id", component: <EditMotorProduct /> },
    { path: "/settings", component: <Settings /> },
    { path: "/reports/policy-reconciliation", component: <PolicyReconciliation /> },
    { path: "/reports/paid-uninsured", component: <PaidUninsured /> },
];

const publicRoutes = [
    { path: "/login", component: <Login /> },
    { path: "/forgot-password", component: <ForgotPassword /> },
    { path: "/forgot-password/reset-password", component: <ResetPassword /> },
];

export { authProtectedRoutes, publicRoutes };